import styled from '@emotion/styled';

export const Container = styled('div')<{overflow?: string}>`
  border-radius: 16px;
  position: relative;

  .swiper {
  }

  .swiper:focus,
  .swiper:focus-visible {
    outline: none;
  }

  .swiper-pagination {
    margin-top: 10px;
    position: relative;
    bottom: 0;
  }

  .swiper-pagination-bullet {
    width: 11px;
    height: 11px;
    background: #c4c4c4;
    border-radius: 50%;
    margin: 0 7px;
    opacity: 1;
  }

  .swiper-pagination-bullet-active {
    background: #f6009b;
  }
`;
